import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES_BG =
  "https://static.prod-images.emergentagent.com/jobs/186afb54-ad9f-4a49-8eb9-c7e4ff21130d/images/8132f0e84c381ee0dcc0ded91d706c4eeb9c187b006369d6bca3192ef7395125.png";

const SERVICES = [
  {
    title: "Séances individuelles gardien",
    body: "Entraînement sur mesure (individuel ou petit groupe). 1h par séance. Travail technique, physique et mental.",
  },
  {
    title: "Analyse vidéo & correction technique",
    body: "Certification Hudle. Décryptage des gestes, des placements et des prises de décision en match.",
  },
  {
    title: "Préparation physique spécifique",
    body: "Détente verticale, réactivité. Adapté aux exigences physiques du poste de gardien.",
  },
  {
    title: "Préparation mentale",
    body: "Concentration, placement, gestion du stress, confiance en soi. Un travail trop souvent négligé dans la formation classique.",
  },
  {
    title: "Observation en match & en club",
    body: "Préparation tactique, 1 observation en match par mois + 1 observation de séance collective. Vision globale du gardien en situation réelle.",
  },
  {
    title: "Suivi & communication tripartite",
    body: "Bilans réguliers transmis au gardien, à l'entourage et au club. Objectifs partagés et mesurables.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 px-6 md:px-12 overflow-hidden border-t border-white/5"
    >
      <div className="absolute inset-0">
        <img src={SERVICES_BG} alt="" className="w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]" />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mb-14"
        >
          CE QUE
          <br />
          <span className="text-[#CCFF00]">JE PROPOSE.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="bg-[#050505] p-8 md:p-10 group hover:bg-[#0a0a0a] transition-colors relative min-h-[240px] flex flex-col"
              data-testid={`service-${i}`}
            >
              <div className="flex items-start justify-end">
                <ArrowUpRight className="w-5 h-5 text-zinc-700 group-hover:text-[#CCFF00] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </div>
              <h3 className="mt-8 font-display text-3xl leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
